import type { ComponentProps } from "react"
import { Dialog as DialogBase } from "@/v2-ui/dialog/base/DialogBase"

export type DialogProps = ComponentProps<typeof DialogBase>

function Dialog(props: DialogProps) {
  const { ...dialogBaseProps } = props
  return <DialogBase {...dialogBaseProps} />
}

export default Dialog
